module.exports = __webpack_public_path__ + "img/icon_intellig_loc_service_select.b5907dd6.svg";